import { Alert } from "@mui/material";
import { txt } from "../../../services/translation";


export default function Help(){

    return (
        <Alert severity='info'>
            <b>{txt('availableVariables')} :</b>
            <br/>
            {`{firstname}`} : {txt('userFirstName')}
            <br/>
            {`{lastname}`} : {txt('userLastName')}
            <br/>
            {`{course}`} : {txt('courseTitle')}
            <br/>
            {`{date}`} : {txt('issueDate')}
            <br/>
            {`{num}`} : {txt('certificateNumber')}
        </Alert>
    );
    
}